import { createSelector } from "@reduxjs/toolkit";
import { selectUniqueSpecifiedArticlesKeys } from "../../Room/rfpValidationSelectors";
import { IValidationColumnMeta } from "./roomTableRfpStandardValidationSelectors";

const formatPct1 = (value: unknown) => {
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? `${n.toFixed(1)} %` : "–";
};

const headerForSpecifiedArticlesKey = (
  key: `specifiedArticles.${string}`,
  suffix: string
): string => {
  const part = key.split(".")[1] ?? "";
  if (part === "overall") return `Artikler ${suffix}`;
  return `Artikler ${part} ${suffix}`;
};

export const selectSpecifiedArticlesValidationColumnMetas = createSelector(
  [selectUniqueSpecifiedArticlesKeys],
  (keys): IValidationColumnMeta[] => {
    const columns: IValidationColumnMeta[] = [];

    keys.forEach((key) => {
      const part = key.split(".")[1] ?? "";

      // overall
      if (part === "overall") {
        columns.push({
          id: `${key}.summary.matchRatePct`,
          header: headerForSpecifiedArticlesKey(
            key as `specifiedArticles.${string}`,
            "andel matchet spesifikasjon"
          ),
          valuePath: ["validation", "specifiedArticles", "summary", "matchRatePct"],
          tooltip: "Treffsikkerhet basert på artikkelspesifikasjon (0–100 %).",
          valueFormatter: formatPct1,
        });
        return;
      }

      // perResponsibility.<RESP>
      columns.push({
        id: `${key}.summary.matchRatePct`,
        header: headerForSpecifiedArticlesKey(
          key as `specifiedArticles.${string}`,
          "andel matchet"
        ),
        valuePath: [
          "validation",
          "specifiedArticles",
          "perResponsibility",
          part,
          "summary",
          "matchRatePct",
        ],
        tooltip: `Treffsikkerhet for responsibility "${part}" (0–100 %).`,
        valueFormatter: formatPct1,
      });
    });

    return columns;
  }
);
